import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IMappingStepItemRespone } from "../../../models/response/mapping/IMappingStepItemRespone";
export enum eMappingReducerStatus {
    is_save_successed = "is_save_successed"
}
export interface IMappingReducer {
    status: ePageBaseStatus | eMappingReducerStatus,
    mappingId: number,
    steps: IMappingStepItemRespone[]
}